import Button from '@mui/material/Button';
import QrCodeIcon from '@mui/icons-material/QrCode';

export default function QRButton({ label, ...props }) {
  return (
    <Button {...props} startIcon={<QrCodeIcon />}>
      {label}
    </Button>
  );
}
